<app-popover>
  <div app-popover-content class="flex flex-col gap-4">
    <button
      *ngIf="data?.item?.trilhas === 0"
      (click)="onCreateSubdivision()"
      app-outline-button
      type="button"
      class="flex border-base-status-info px-4 py-2 uppercase text-base-status-info hover:[&:not([disabled])]:bg-base-status-info hover:[&:not([disabled])]:text-theme-contrast"
    >
      <svg-icon src="assets/icons/icon-more.svg"></svg-icon>
      {{ 'trilhas.estudio.subdivisao.adicionar' | translate }}
    </button>
    <button
      *ngIf="data?.item?.trilhas > 0 || data?.item?.items?.length === 0"
      app-outline-button
      type="button"
      (click)="onAddTrail()"
      class="flex border-base-status-info px-4 py-2 uppercase text-base-status-info hover:[&:not([disabled])]:bg-base-status-info hover:[&:not([disabled])]:text-theme-contrast"
    >
      <svg-icon src="assets/icons/icon-more.svg"></svg-icon>
      {{ 'trilhas.estudio.trilha.adicionar' | translate }}
    </button>
    <hr app-divider />
    <button
      (click)="onEditSubdivision()"
      app-outline-button
      type="button"
      class="flex border-base-status-warning px-4 py-2 uppercase text-base-status-warning hover:[&:not([disabled])]:bg-base-status-warning hover:[&:not([disabled])]:font-semibold hover:[&:not([disabled])]:text-theme-contrast"
    >
      <svg-icon src="assets/icons/icon-more.svg"></svg-icon>
      {{ 'geral.editar' | translate }}
    </button>
    <button
      *ngIf="data?.item?.trilhas === 0 && data?.item?.items?.length === 0"
      (click)="onDeleteSubdivision()"
      app-outline-button
      type="button"
      class="flex border-base-status-danger px-4 py-2 uppercase text-base-status-danger hover:[&:not([disabled])]:bg-base-status-danger hover:[&:not([disabled])]:text-theme-contrast"
    >
      <svg-icon src="assets/icons/icon-more.svg"></svg-icon>
      {{ 'geral.excluir' | translate }}
    </button>
  </div>
</app-popover>
